import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { TermsAndConditionsResponse } from '..';
import { QuestionAnswerValueType } from '../models';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';

@Injectable()
export class TermsAndConditionsService {
  private path = 'questionandanswers';
  private extraHeaders: { [name: string]: string } = {};

  constructor(private httpService: HttpService, private appConfigService: AppConfigService) {
    
  }

  public getTermsAndConditions(): Observable<Array<TermsAndConditionsResponse>> {
    return this.getQuestionAnswerContent(QuestionAnswerValueType.TermsAndConditions);
  }

  public getFAQ(): Observable<Array<TermsAndConditionsResponse>> {
    return this.getQuestionAnswerContent(QuestionAnswerValueType.FAQ);
  }

  public getPrivacyPolicy(): Observable<Array<TermsAndConditionsResponse>> {
    return this.getQuestionAnswerContent(QuestionAnswerValueType.PrivacyPolicy);
  }

  private getQuestionAnswerContent(valueType: QuestionAnswerValueType): Observable<Array<TermsAndConditionsResponse>> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if(this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    this.extraHeaders['CompanyGuid'] = companyGUID;
    const pathWithQuery = `${this.path}?ValueType=${valueType}`;
    return this.httpService.makeGet<Array<TermsAndConditionsResponse>>(pathWithQuery, null, 'json', this.extraHeaders);
  }
}
